import { ComponentProps } from 'react';
import { bordColorTheme } from '../../../../styles/styles.constants';

const BordDoubleCheckIcon = (props: ComponentProps<'svg'>) => {
  const { stroke } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 9">
      <path
        stroke={stroke || bordColorTheme.navyBlue[400]}
        strokeLinecap="round"
        strokeLinejoin="round"
        d="m.5 5.389 2.333 2.444.683-.715M9.833.5 5.791 4.734M3.833 5.389l2.333 2.444 7-7.333"
      />
    </svg>
  );
};

export default BordDoubleCheckIcon;
